export default __webpack_public_path__ + "static/media/Seth.c2bb36c5.png";